import {createContext, useContext} from "react";

export type ServerTableToolbarPanel = 'sort' | 'filter' | 'columns';

interface ActivePanel {
    type: ServerTableToolbarPanel
    anchor: HTMLElement
}

interface ServerTableToolbarContextValue {
    activePanel: ActivePanel | null
    openPanel: (type: ServerTableToolbarPanel, anchor: HTMLElement) => void
    closePanel: () => void
    /** Hoisted toolbars have no row to expand into, so search takes over the header. */
    searchSurface: 'inline' | 'overlay'
    isSearchOpen: boolean
    openSearch: () => void
    closeSearch: () => void
}

interface ServerTableToolbarItemContextValue {
    presentation: 'toolbar' | 'menu' | 'overlay'
    menuAnchor: HTMLElement | null
    closeMenu: () => void
}

export const ServerTableToolbarContext = createContext<ServerTableToolbarContextValue | null>(null);
export const ServerTableToolbarItemContext =
    createContext<ServerTableToolbarItemContextValue | null>(null);

export const useServerTableToolbarContext = () => {
    const context = useContext(ServerTableToolbarContext);
    if (!context) throw new Error('Server table controls must be rendered inside ServerTableToolbar.');

    return context;
};

export const useServerTableToolbarItemContext = () => {
    const context = useContext(ServerTableToolbarItemContext);
    if (!context) throw new Error('Server table controls must be rendered inside ServerTableToolbar.');

    return context;
};
